import * as React from "react";
import { forwardRef } from "react";
const SvgIconToday = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.13 5v.783H5V23h17.217V5.783h-3.13V5h-1.565v.783H9.7V5zM6.565 7.348H8.13v.782H9.7v-.782h7.826v.782h1.565v-.782h1.565v1.565H6.565zm0 3.13h14.087v10.957H6.565zm10.394 1.785L12.826 16.4l-1.785-1.785-1.125 1.121 2.348 2.348.562.538.563-.538 4.7-4.7z", "data-name": "icon/today", transform: "translate(-4.609 -5)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconToday);
export { ForwardRef as ReactComponent };
